import React, {FC} from 'react';
import styled from 'styled-components';

import {OkCancelDialog} from '../../../../../../../src/components/common/dialogs/okCancelDialog';
import {AccountModel} from '../../../../../../../src/models/api/accountModel';
import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../shared/ui/src/components/buttons/buttonConstants';

/*
 * Props.
 */

interface DeleteAccountConfirmationDialogProps {
  account: AccountModel;
  onClose: Handler;
  onDelete: Handler;
}

/*
 * Styles.
 */

const StyledOkCancelDialog = styled(OkCancelDialog)`
  margin: 0 16px;
`;

/*
 * Component.
 */

export const DeleteAccountConfirmationDialog: FC<DeleteAccountConfirmationDialogProps> = (props) => {
  const {account, onClose, onDelete} = props;
  return (
    <StyledOkCancelDialog
      title={<Trans id="delete-account-confirmation-dialog-title">Delete {account.name}</Trans>}
      okButtonLabel={
        <Trans id="delete-account-confirmation-dialog-delete-permanently">Delete permanently</Trans>
      }
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onClose}
      onOkClick={onDelete}
    >
      <Trans id="delete-account-confirmation-dialog-permanent-delete-warning">
        This account will be permanently deleted in Front. This action cannot be undone. Contacts associated
        with this account will not be deleted.
      </Trans>
    </StyledOkCancelDialog>
  );
};
